/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-10-26 13:48:39 */

const Keys = {
  adult: 'adult',
  adult_other: 'adult_other',
  child: 'child',
  child_other: 'child_other',
  infant: 'infant',
  infant_other: 'infant_other',
  adultsLabel: 'adultsLabel',
  childrenLabel: 'childrenLabel',
  infantsLabel: 'infantsLabel',
  button: 'button',
  traveler: 'traveler',
  traveler_other: 'traveler_other',
  guest: 'guest',
  guest_other: 'guest_other',
  room: 'room',
  roomsLabel: 'roomsLabel',
  room_other: 'room_other',
  addRoom: 'addRoom',
  travellerAgeInfo: 'travellerAgeInfo',
  age: 'age',
  ageCapitalized: 'ageCapitalized',
  validationErrorMessage: 'validationErrorMessage',
  childAgeErrorMessage: 'childAgeErrorMessage',
  dateValidationErrorMessage: 'dateValidationErrorMessage',
  dateRangeNotSelectedErrorMessage: 'dateRangeNotSelectedErrorMessage',
  childAgeRange: 'childAgeRange',
  infantAgeRange: 'infantAgeRange',
  adultAgeRange: 'adultAgeRange',
  pleaseSelect: 'pleaseSelect',
  updateSearch: 'updateSearch',
  occupancyErrorMessage: 'occupancyErrorMessage',
  select: 'select',
  selectAll: 'selectAll',
  preselectAllHotelsCheckbox: 'preselectAllHotelsCheckbox',
  selectedHotelsLabel: 'selectedHotelsLabel',
  hotel: 'hotel',
  search: 'search',
  listOfHotels: 'listOfHotels',
  priceInformation: 'priceInformation',
  iconsLegend: 'iconsLegend',
  nextMonth: 'nextMonth',
  previousMonth: 'previousMonth'
}; export default Keys;